// const SERVER_URL = 'https://genode-api.widelyapps.net/';
const SERVER_URL = 'https://api.genode.co/';

const API_CHANGE_PASSWORD = 'api/ChangePassword';
const API_FORGET_PASSWORD = 'api/ForgotPassword';

//const API_HOSPITAL_FILTER = 'api/hospital';
const API_HOSPITAL_FILTER = 'api/hospitalbydoctor';


const API_LAB_RESULT_FILE = 'api/LabResultFile';

//const API_LAB_TEST_TYPE = 'api/lab_testtype';
const API_LAB_TEST_TYPE = 'api/testtype';


const API_LOGIN = 'api/Login';
const API_LOGOUT = 'api/Logout';
const API_MEMBER_PROFILE = 'api/MemberProfile';
const API_OTP_VERIFY = 'api/OTPVerify';
const API_REGISTER = 'api/RegisterByPhoneOrMail';
const API_SETPASSWORD = 'api/SetPassword';
const API_TESTCASE_LIST = 'api/TestCaseList';
const API_TESTPROCESS_STATUS_LIST = 'api/testprocess';
const TOKEN = 'token';
const RESULT_ID = 'result_id';

export default{
  SERVER_URL,
  API_CHANGE_PASSWORD,
  API_FORGET_PASSWORD,
  API_HOSPITAL_FILTER,
  API_LAB_RESULT_FILE,
  API_LAB_TEST_TYPE,
  API_LOGIN,
  API_LOGOUT,
  API_MEMBER_PROFILE,
  API_OTP_VERIFY,
  API_REGISTER,
  API_SETPASSWORD,
  API_TESTCASE_LIST,
  API_TESTPROCESS_STATUS_LIST,
  TOKEN,
  RESULT_ID
}



// WEBPACK FOOTER //
// ./src/components/Config.js